module.exports = __webpack_public_path__ + "img/v33_11.5692b28f.png";